// extracted by mini-css-extract-plugin
export var charcoal = "countdown-module--charcoal--f615c";
export var container = "countdown-module--container--be854";
export var countdown = "countdown-module--countdown--46855";
export var displayed = "countdown-module--displayed--ffa51";
export var headline = "countdown-module--headline--102d2";
export var lightSand = "countdown-module--lightSand--8967d";
export var white = "countdown-module--white--d6e52";